var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 44C88 41.68 80.89 38.9 69.94 37.05C78.49 29.98 83.27 24.01 82.1 22C80.94 19.99 73.39 21.14 62.98 25.01C66.85 14.61 68 7.05999 65.99 5.88999C63.98 4.72999 58.02 9.49999 50.94 18.05C49.09 7.10999 46.31 -0.0100098 43.99 -0.0100098C41.67 -0.0100098 38.89 7.09999 37.04 18.05C29.97 9.49999 24 4.71999 21.99 5.88999C19.98 7.04999 21.13 14.6 25 25.01C14.6 21.14 7.04998 19.99 5.87998 22C4.71998 24.01 9.48998 29.97 18.04 37.05C7.09998 38.9 -0.0200195 41.68 -0.0200195 44C-0.0200195 46.32 7.08998 49.1 18.04 50.95C9.48998 58.02 4.70998 63.99 5.87998 66C7.03998 68.01 14.59 66.86 25 62.99C21.13 73.39 19.98 80.94 21.99 82.11C24 83.27 29.96 78.5 37.04 69.95C38.89 80.89 41.67 88.01 43.99 88.01C46.31 88.01 49.09 80.9 50.94 69.95C58.01 78.5 63.98 83.28 65.99 82.11C68 80.95 66.85 73.4 62.98 62.99C73.38 66.86 80.93 68.01 82.1 66C83.26 63.99 78.49 58.03 69.94 50.95C80.88 49.1 88 46.32 88 44Z",
    fill: "#6D247A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon_11.2038009f14f9e480333f668b05e95f86.svg";
export { ForwardRef as ReactComponent };